@if (isAdmin()) {
  <mat-tab-group>
    <mat-tab label="Productos">
      <app-admin-product-list></app-admin-product-list>
    </mat-tab>
    <mat-tab label="Categorias">
      <app-admin-categories></app-admin-categories>
    </mat-tab>
  </mat-tab-group>

} @else {
  <app-admin-product-list></app-admin-product-list>
}
